export function getContratistas(state) {
  return state.contratistas.data.filter(contratista => {
    return contratista.nombre
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .includes(
        state.contratistas.filtro
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
      )
  });
}
